'use strict';

exports.__esModule = true;
exports.default = CustomChat;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Parser = require('./Parser');

var _Parser2 = _interopRequireDefault(_Parser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CustomChat(props) {
  var className = props.className,
      minimized = props.minimized,
      children = props.children,
      pageId = props.pageId,
      onParse = props.onParse,
      themeColor = props.themeColor,
      loggedInGreeting = props.loggedInGreeting,
      loggedOutGreeting = props.loggedOutGreeting;


  return _react2.default.createElement(
    _Parser2.default,
    { className: className, onParse: onParse },
    _react2.default.createElement(
      'div',
      {
        className: 'fb-customerchat',
        page_id: pageId,
        minimized: minimized,
        theme_color: themeColor,
        logged_in_greeting: loggedInGreeting,
        logged_out_greeting: loggedOutGreeting
      },
      children
    )
  );
}

CustomChat.defaultProps = {
  minimized: undefined,
  children: undefined,
  className: undefined,
  onParse: undefined,
  themeColor: undefined,
  loggedInGreeting: undefined,
  loggedOutGreeting: undefined
};
//# sourceMappingURL=CustomChat.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/CustomChat.js
// module id = 1222
// module chunks = 198517197184460